<template>
  <div>
	  <div class="page-bg">
			<div class="logo">
				<img src="../assets/logo.png" alt="" />
			</div>
				
	  		<div class="task-checkin-page">
				
				<div class="title-bar fcc anim-title">
					<img src="../assets/slogen-page.png" alt="" />
				</div>
				<div class="task-checkin-list">
					<div class="item anim-card" style="animation-delay:0.1s" @click="openUrl('/checkin?type=1')">
						<img src="../assets/img-nav1.png" alt="" srcset="" />
						<span class="card-label">签到打卡</span>
					</div>
					<div class="item anim-card" style="animation-delay:0.2s" @click="openUrl('/checkin?type=2')">
						<img src="../assets/img-nav2.png" alt="" srcset="" />
						<span class="card-label">游戏打卡</span>
					</div>
					<div class="item anim-card" style="animation-delay:0.3s" @click="openUrl('/checkin?type=3')">
						<img src="../assets/img-nav3.png" alt="" srcset="" />
						<span class="card-label">分享打卡</span>
					</div>
					<div class="item anim-card" style="animation-delay:0.4s" @click="openUrl('/checkin?type=4')">
						<img src="../assets/img-nav4.png" alt="" srcset="" />
						<span class="card-label">大魔王任务</span>
					</div>
					<div class="item anim-card" style="animation-delay:0.5s" @click="openUrl('/checkin?type=5')">
						<img src="../assets/img-nav5.png" alt="" srcset="" />
						<span class="card-label">课程互动</span>
					</div>
					<div class="item anim-card" style="animation-delay:0.6s" @click="openUrl('/checkin?type=6')">
						<img src="../assets/img-nav6.png" alt="" srcset="" />
						<span class="card-label">个人风采</span>
					</div>
				</div>
			</div>
			
			<i-nav></i-nav>
	  </div>
	  
 


  </div>
</template>

<script>


export default {

  data() {
    return {
		
        
       
    };
  },
  async mounted() {
    this.uid = window.localStorage.getItem('cscec2026UserId')
		if (!this.uid) {
			this.$router.push({ path: '/' })
			return
		}
	

  },
  methods: {
    
    
  },
};
</script>
<style  scoped lang="less">
	.anim-title {
		animation: fadeUp 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
	}
	.anim-card {
		opacity: 0;
		animation: fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
	}
	@keyframes fadeUp {
		from {
			opacity: 0;
			transform: translateY(20px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
	.card-label {
		margin-top: 12px;
		font-size: 24px;
		font-weight: 500;
		color: #1d1d1f;
	}
</style>

